import SlsWorkFlowClient from '@/api/SistemaDKP/Workflow/sis-workflow.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSWorkFlowService {
  constructor() {
    this.client = new SlsWorkFlowClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os workflow');
    }
  }

  async findByTipoWorkflow(workflowtipoid) {
    try {
      const { data } = await this.client.index(workflowtipoid);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os workflow');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar workflow');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar workflow');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar workflow');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar workflow');
    }
  }
}
